<script setup lang="ts">
import { ref } from 'vue'
import { authState } from '../services/auth'
import DsIcon from './DsIcon.vue'

const menuOpen = ref(false)
</script>

<template>
  <header class="app-header">
    <div class="shell header-inner">
      <RouterLink class="app-brand" to="/" aria-label="叮球网页版首页">
        <span class="brand-ball" aria-hidden="true"></span>
        <span>叮球</span>
        <small>DINGTENNIS</small>
      </RouterLink>
      <nav class="desktop-nav" aria-label="主导航">
        <RouterLink to="/">首页</RouterLink>
        <RouterLink to="/find">找球</RouterLink>
        <RouterLink to="/me/activities">我的活动</RouterLink>
      </nav>
      <div class="header-actions">
        <RouterLink class="button button-quiet hide-mobile" to="/activities/new"><DsIcon name="add" :size="18" />发布活动</RouterLink>
        <RouterLink class="avatar-button" :to="authState ? '/me' : '/login'" :aria-label="authState ? '用户中心' : '注册/登录'">
          <img v-if="authState?.user.avatarUrl" :src="authState.user.avatarUrl" alt="" />
          <DsIcon v-else name="person" :size="20" />
          <span class="hide-mobile">{{ authState?.user.nickname || '注册/登录' }}</span>
        </RouterLink>
        <button class="menu-button show-mobile" type="button" :aria-expanded="menuOpen" :aria-label="menuOpen ? '关闭导航菜单' : '打开导航菜单'" @click="menuOpen = !menuOpen">
          <DsIcon :name="menuOpen ? 'close' : 'menu'" :size="22" />
        </button>
      </div>
    </div>
    <nav v-if="menuOpen" class="mobile-menu show-mobile" aria-label="移动导航" @click="menuOpen = false">
      <RouterLink to="/">首页</RouterLink>
      <RouterLink to="/find">找球</RouterLink>
      <RouterLink to="/activities/new">发布活动</RouterLink>
      <RouterLink :to="authState ? '/me' : '/login'">{{ authState ? '用户中心' : '注册/登录' }}</RouterLink>
    </nav>
  </header>
</template>
